export const menu = {
  menu_title: 'Resonance',
  // Header slot actions (ResonanceLayout)
  header_menu_aria: 'القائمة',
  header_island_settings_aria: 'إعدادات الجزر',
  header_call_aria: 'الاتصال بالرقم {{number}}',
  menu_logOut: 'تسجيل الخروج',
  menu_language_button_text: 'تغيير',
  menu_languages_modal_title: 'اختر لغتك',
  menu_questionnaires_modal_title: 'اختر استبيانًا',
  menu_share_title: '{{appName}}',
  menu_share_text: 'اكتشف {{appName}} 🙂',
  menu_share_link_copied: 'تم نسخ رابط دعوة {{appName}} إلى الحافظة ✅',
  menu_share_not_supported: 'المشاركة غير مدعومة على هذا الجهاز.',
  menu_share_link_error: 'تعذر إنشاء رابط دعوة في الوقت الحالي.',
  menu_share_no_public_link: 'لا يوجد رابط دعوة عام مُعدّ.',
};
